import { FiMove, FiDroplet, FiSettings } from "react-icons/fi";
import { LuBrainCircuit } from "react-icons/lu";

export const TRANSFORM_TAB = {
  id: "transform",
  label: "Transform",
  icon: FiMove,
};

// Only node types with properties beyond transform get extra tabs.
const EXTRA_TABS_BY_TYPE = {
  mesh: [
    { id: "material", label: "Material", icon: FiDroplet },
    { id: "ai", label: "AI", icon: LuBrainCircuit },
  ],
  light: [
    { id: "settings", label: "Light Settings", icon: FiSettings },
    { id: "ai", label: "AI", icon: LuBrainCircuit },
  ],
  camera: [{ id: "settings", label: "Camera Settings", icon: FiSettings }],
  // A "Null" has no material/settings — used purely as a group pivot — but
  // still benefits from an AI description of what it represents.
  null: [{ id: "ai", label: "AI", icon: LuBrainCircuit }],
};

export function tabsForNodeType(type) {
  return [TRANSFORM_TAB, ...(EXTRA_TABS_BY_TYPE[type] || [])];
}

// Fixed left-to-right column order for every *extra* tab a hierarchy row
// might show (after the always-present Transform tab) — HierarchyPanel.jsx
// renders one slot per id here for every row, real button or empty
// placeholder, so e.g. "AI" always lands in the same column whether the row
// above it is a mesh, a light, or a null, instead of sliding around based on
// how many tabs *that* row's type happens to have.
export const EXTRA_TAB_COLUMNS = ["material", "settings", "ai"];

// The fixed "World" hierarchy row isn't a node (no transform), so it gets
// its own tab set rather than going through tabsForNodeType. Projections used
// to live here too, but moved out to their own top-level sidebar tab (see
// Scene3DEditor.jsx) since a projection is scene-wide, not a World setting.
export const WORLD_TABS = [
  { id: "settings", label: "Ambient Settings", icon: FiSettings },
  { id: "ai", label: "AI", icon: LuBrainCircuit },
];
